export default __webpack_public_path__ + "static/media/Pilgrim's Belt of the Three Clarities.29f2e8e9.jpg";